<template>
  <!-- Home.vue -->
  <div>
    <Spinner v-if="!isInitialized" />
    <v-app v-if="isInitialized">
      <v-navigation-drawer app v-model="drawer">
        <v-list>
          <template v-for="item in navigation">
            <v-list-item v-if="!('items' in item)" :key="item.title" link :to="item.route">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group v-else :key="item.title" v-model="item.active" no-action>
              <template #prependIcon>
                <v-icon v-if="item.icon !== 'svg'">{{ item.icon }}</v-icon>
                <img v-else :src="item.svg" class="menu-svg-icon" />
              </template>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item v-for="child in item.items" :key="child.title" link :to="child.route">
                <v-list-item-icon>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="child.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>

          <v-divider></v-divider>
          <v-list-item v-for="item in navigationSiteWide" :key="item.title" link :to="item.route">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item v-for="item in _navigationMisc" :key="item.title" link :to="item.route">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <template v-slot:append>
          <v-list-item link @click="goToMail">
            <v-list-item-icon>
              <v-icon>mdi-mailbox-open-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Webmail</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="signout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logga ut</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-navigation-drawer>

      <v-app-bar app color="#fff" elevation="1">
        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

        <div class="w-100 menu-row">
          <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
          <v-toolbar-title>
            <img class="logo" :src="logo" />
          </v-toolbar-title>
          <v-btn icon @click="signout">
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </div>
      </v-app-bar>

      <!-- Sizes your content based upon application components -->
      <v-main>
        <!-- Provides the application the proper gutter -->
        <v-container class="w-100">
          <!-- If using vue-router -->
          <router-view />
        </v-container>
      </v-main>

      <!-- <v-footer app>

    </v-footer> -->
      <ImageViewer />
    </v-app>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import logo from '@/assets/head-logga_admin.gif'
import iconHavet from '@/assets/favicon_havet.svg'
import iconLivet from '@/assets/favicon_livet.svg'
import iconHavsutsikt from '@/assets/favicon_havsutsikt.svg'
import { ADMIN, DEVELOPER } from '@/assets/data/userRoles'
import Spinner from '@/components/shared/Spinner'
import { checkFeatureFlag } from '@/lib/FeatureFlag.js'
import ImageViewer from '@/views/images/ImageViewer.vue'

export default {
  name: 'App',
  components: {
    Spinner,
    ImageViewer,
  },
  data() {
    return {
      shouldSeeContacts: false,
      isInitialized: false,
      logo,
      drawer: true,
      navigation: [
        { title: 'Start', icon: 'mdi-home-outline', route: { name: 'Start' } },
        {
          title: 'Havet',
          icon: 'svg',
          svg: iconHavet,
          items: [
            {
              title: 'Nyheter',
              icon: 'mdi-newspaper-variant-outline',
              route: { name: 'NewsList' },
            },
            {
              title: 'Rapporter',
              icon: 'mdi-card-text-outline',
              route: { name: 'ReportsList', params: { section: 'avhandlingar' } },
            },
            {
              title: 'Sidor',
              icon: 'mdi-book-open-page-variant-outline',
              route: { name: 'Pages', params: { section: 'havet' } },
            },
            {
              title: 'Sökningar',
              icon: 'mdi-search-web',
              route: { name: 'SearchLogs', params: { section: 'havet' } },
            },
          ],
        },
        {
          title: 'Livet',
          icon: 'svg',
          svg: iconLivet,
          items: [
            {
              title: 'Arter',
              icon: 'mdi-fish',
              route: { name: 'ArterList' },
            },
            {
              title: 'Faktarutor',
              icon: 'mdi-card-bulleted-outline',
              route: { name: 'ArterFacts' },
            },
            {
              title: 'Sidor',
              icon: 'mdi-book-open-page-variant-outline',
              route: { name: 'Pages', params: { section: 'livet' } },
            },
          ],
        },
        {
          title: 'Havsutsikt',
          icon: 'svg',
          svg: iconHavsutsikt,
          items: [
            {
              title: 'Sidor',
              icon: 'mdi-book-open-page-variant-outline',
              route: { name: 'Pages', params: { section: 'havsutsikt' } },
            },
          ],
        },
      ],

      navigationMisc: [
        {
          title: 'Redaktörer',
          icon: 'mdi-account-group-outline',
          route: { name: 'RedaktorerHome' },
        },
        {
          title: 'Inställningar',
          icon: 'mdi-account-cog-outline',
          route: { name: 'SettingsHome' },
        },
      ],
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUserRole']),
    _navigationMisc() {
      return this.navigationMisc.filter((nav) => {
        if ([ADMIN, DEVELOPER].includes(this.currentUserRole)) return true // Include all if admin or developer
        if (nav.title === 'Redaktörer') return false // Don't show redaktörer unless admin or developer
        return true
      })
    },
    navigationSiteWide() {
      const items = [
        { title: 'Bilder ', icon: 'mdi-image-outline', route: { name: 'ImagesList' } },
        { title: 'Kontakter ', icon: 'mdi-account-box-outline', route: { name: 'ContactsHome' } },
      ]
      return this.shouldSeeContacts ? items : items.filter((item) => item.title !== 'Kontakter ')
    },
  },
  methods: {
    ...mapMutations('auth', ['SIGN_OUT']),
    ...mapMutations('tags', { mutTagsFilter: 'ADD_FILTER' }),
    ...mapActions('user', { getAllUsers: 'readCollection' }),
    ...mapActions('tags', { tagsReadCollection: 'readCollection' }),
    signout() {
      this.SIGN_OUT()
      this.$router.push({ name: 'SignIn' })
    },
    goToMail() {
      window.open('https://webmail.websupport.se/', '_blank')
    },
  },
  async created() {
    const userId = this.$store.getters['auth/getUserId']()
    const user = await this.$store.dispatch('user/read', {
      id: userId,
    })
    this.$store.commit('auth/SET_USER', user)
    this.$store.commit('auth/SET_USERID', userId)
    await this.getAllUsers()
    this.mutTagsFilter({ key: 'pageSize', value: 9999 })
    await this.tagsReadCollection()
    this.shouldSeeContacts = await checkFeatureFlag('shouldSeeContacts')
    this.isInitialized = true
  },
}
</script>
<style lang="less">
.logo {
  height: 50px;
  transform: translateY(5px);
}
.menu-row {
  width: 100%;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}
.menu-svg-icon {
  width: 20px;
  margin-left: 2px;
}
</style>
